import LaunchIcon from '@material-ui/icons/Launch';
import type { ProjectFileData } from '@mogul/api-client';
import type { FC } from 'react';

import styles from './AdditionalInfo.module.css';
import { ReactComponent as MogulLogo } from './mogul-logo.svg';

export interface CastAndCrewData {
  name: string;
  imageUrl: string;
  role: string;
  imdbUrl: string;
}

export interface DetailsProps {
  description: string;
  cast: CastAndCrewData[];
}
export interface AdditionalInfoProps {
  budget: string;
  additionalDetails: ProjectFileData[];
}

export const Details: FC<DetailsProps> = ({ description, cast }) => {
  return (
    <div className={styles.infoContainer + ' my-8'}>
      <div className="flex flex-col lg:flex-row">
        {description && (
          <div
            className={
              'flex pb-2 flex-col w-full' +
              (cast.length > 0 ? ' lg:w-1/2' : ' lg:w-full')
            }
          >
            <div className="text-primary font-vanguard font-bold text-5xl mt-6 ml-6">
              Description
            </div>
            <div className="text-white font-noto-sans text-xs mt-4 mx-6 opacity-70">
              {description}
            </div>
          </div>
        )}
        {cast.length > 0 && (
          <div
            className={
              'flex flex-col w-full' +
              (description ? ' lg:w-1/2' : ' lg:w-full')
            }
          >
            <div className="text-primary font-vanguard font-bold text-5xl mt-6 ml-6">
              Team
            </div>
            <div className="grid grid-flow-row grid-cols-4 grid-rows-3 gap-4 my-4 mx-6 opacity-70">
              {cast.map((c, i) => (
                <div key={i}>
                  <div
                    className={
                      styles.actor +
                      ' font-noto-sans text-xs font-bold uppercase'
                    }
                  >
                    {c.role}
                  </div>
                  <a
                    target="_blank"
                    className="hover:underline cursor-pointer"
                    href={c.imdbUrl}
                    rel="noreferrer"
                  >
                    {c.name}
                  </a>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export const AdditionalInfo: FC<AdditionalInfoProps> = ({
  additionalDetails,
}) => {
  return (
    <div className={styles.infoContainer + ' my-8'}>
      {!!additionalDetails.length && (
        <div className="flex flex-col">
          <div className="text-primary font-vanguard font-bold text-5xl mt-6 ml-6">
            Additional Details
          </div>
          <div
            className={`grid lg:grid-cols-3 grid-cols-1 gap-4 my-6 mx-6 ${
              additionalDetails.length > 0 ? 'h-auto min-h-full' : ''
            }`}
          >
            {additionalDetails.map(details => (
              <a
                key={details.id}
                target="_blank"
                href={details.file.publicUrl}
                className={`rounded-xl border-2 pb-3 border-yellow-300 border-solid flex flex-col hover:underline`}
                rel="noreferrer"
              >
                <div className="w-full h-40 rounded-t-xl border-2 flex items-center justify-center bg-white">
                  <MogulLogo />
                </div>
                <div className="ml-3 mt-3">
                  <h1 className="text-white font-vanguard font-bold text-3xl m-0">
                    {details.label.toLowerCase() === 'synopsis'
                      ? 'DESCRIPTION'
                      : details.label}
                    <LaunchIcon className="ml-2 text-primary" />
                  </h1>
                  <p className="text-white font-noto-sans text-base mt-3 mb-2 h-24 overflow-hidden overflow-ellipsis">
                    {details.description}
                  </p>
                  {new URL(details.file.publicUrl).hostname}
                </div>
              </a>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};
